import AuthService from "./Auth";
import MsiService from "./Msi";
import CardsService from "./Cards";
import OffersService from "./Offers";
import LoanService from "./Loan";
import AgreementService from "./Agreement";
import MessagesService from "./Messages";
import ClaimService from "./Claim";

export class HttpService {
  constructor() {
    this.auth = AuthService;
    this.msi = MsiService;
    this.card = CardsService;
    this.offers = OffersService;
    this.loan = LoanService;
    this.agreement = AgreementService;
    this.message = MessagesService;
    this.claim = ClaimService;

    window.$httpService = this;
  }
}

export default HttpService;